export enum DialogResultEnum
{
    none = "none",
    ok = "ok",
    yes = "yes",
    no = "no",
    abort = "abort",
    retry = "retry",
    ignore = "ignore",
    cancel = "cancel",
}